export default {
    ru: {
        'About SecurOS': 'О приложении',
        'Privace policy': 'Политика конфиденциальности',
        'Help': 'Помощь',
        'Save': 'Сохранить',
        'Save as': 'Сохранить как',
        'Cancel': 'Отмена',
        'Reset': 'Сбросить',
        'Download': 'Загрузить',
        'Download all': 'Загрузить всё',
        'Undo сhanges': 'Отменить изменения',
        'Clear View': 'Очистить область',
        'Change language': 'Сменить язык',
        'Select language': 'Выберите язык',
        'Logout': 'Выйти',
        'Save object': 'Сохранение объекта',
        'Object': 'Объект',
        'Alarms': 'Тревоги',
        'Live': 'Живое',
        'Playback': 'Архив',
        'Cameras': 'Камеры',
        'Views': 'Виды',
        'View all': 'Смотреть все',
        'Find cameras': 'Найти камеры',
        'Find alarms': 'Найти тревоги',
        'Find object': 'Найти объект',
        'Map': 'Карта',
        'Video': 'Видео',
        'drop cams': 'Для начала просмотра перетяните камеры сюда. Вид не будет сохранен автоматически и будет потерян при перезапуске',
        'No cameras': 'Нет камер',
        'No signal': 'Нет сигнала',
        'Main View': 'Главный вид',
        'Delete view': 'Удалить вид',
        'Rename': 'Переименовать',
        'Remove': 'Удалить',
        'Are you sure you want to delete view?': 'Вы действительно хотите удалить вид?',
        'Save view': 'Сохранение вида',
        'View name': 'Название вида',
        'New object': 'Новый объект',
        'Forgot password?': 'Забыли пароль?',
        'Login': 'Логин',
        'Password': 'Пароль',
        'Add object': 'Добавить объект',
        'Enter': 'Войти',
        'Forgot password message': 'Чтобы получить доступ или изменить пароль, свяжитесь с системным администратором.',
        'Save credentials': 'Запомнить меня',
        'No alarms for this period': 'Нет тревог за данный период',
        'Image unavailable': 'Изображение недоступно',
        'Location on map': 'Расположение на карте',
        'IDs cameras': 'ID камер',
        'Views with camera': 'Виды с камерой',
        'View': 'Вид',
        'View camera': 'Просмотр камеры',
        'No cameras': 'Нет камер',
        'max cameras error': 'Текущая сетка не может вместить в себя большее количество камер. Измените параметры сетки',
        'Fit into window': 'Вписать в окно',
        'Service is temporarily unavailable': 'Сервис временно недоступен',
        'Error': 'Ошибка',
        'You can not create more than 10 views': 'Вы не можете создать больше 10 видов',
        'Error IE': 'Internet Explorer не поддерживается SecurOS WebConnect. Пожалуйста, используйте Google Chrome, ' +
            'Mozilla Firefox, Safari, MS Edge или другой современный браузер.',
        'Indicate alarms on cameras': 'Обозначить тревожные камеры',

        // Разрешение видео
        'Base': 'Базовый',
        'Low resolution': 'Низкое разрешение',
        'High resolution': 'Высокое разрешение',
 
        // Работа с выгрузкой видео
        'Video Complete': 'Файл готов к загрузке',
        'Video Loading': 'Файл готовится к загрузке',
        DOWNLOADING: 'Загрузка видео',
        VIDEO_EXPORT_PERIOD: 'Выберите период для сохранения',

        // Статусы камер
        CAM_ALARMED: 'Тревога',
        CAM_ARMED: 'Поставлена на охрану',
        CAM_DETACHED: 'Нет сигнала',
        CAM_DISARMED: 'Снята с охраны',
        CAM_DISARM_DETACHED: 'Нет сигнала',

        // Статусы событий
        EVENT_ATTACH: 'Камера подключена',
        EVENT_BLINDING: 'Плохая видимость',
        EVENT_DETACH: 'Нет видео',
        EVENT_DEFOCUSED: 'Потеря фокусировки',
        EVENT_FOCUSED: 'Сфокусирована',
        EVENT_MD_START: 'Тревога',
        EVENT_MD_STOP: 'Конец тревоги',
        EVENT_REC: 'Запись на диск',
        EVENT_REC_STOP: 'Конец записи на диск',
        EVENT_UNBLINDING: 'Хорошая видимость',
        EVENT_ARMED: 'Камера была поставлена на охрану',
        EVENT_DISARMED: 'Камера была снята с охраны ',
        EVENT_REC_ERROR: 'Ошибка записи',

        // Кастомные ошибки валидации
        uniqueObject: 'Объект с указанными именем уже существует.',
        uniqueLogin: 'Объект с указанным логином уже существует.',
        auth: "Не найден аккаунт с указанными логином и паролем.",
        wrongPassword: 'Неправильный пароль.',
        uniqueViewName: 'Вид с указанными именем уже существует.',
        disableRoot: 'Авторизация суперпользователя (root) запрещена политикой безопасности. Пожалуйста, используйте другую учетную запись пользователя.',

        validation: {
            messages: {
                required: (field) => `Поле "${field}" обязательно для заполнения.`,
                regex: (field) => `Поле "${field}" содержит недопустимые символы.`,
            },
        },
    },
    en: {
        'drop cams': 'Drop cameras here to start watching video. View is not saved automatically and will be lost after restart.',
        'Forgot password message': 'Please contact your SecurOS system administrator to receive user credentials or to change your account password.',
        'max cameras error': 'The current layout can support no more cameras. Please, change the layout details',

		'About SecurOS': 'About',
        'Save object': 'Save site',
        'Object': 'Site',
		'Find object': 'Find location',
		'New object': 'New site',
        'Add object': 'Add site',
        'Error IE': 'Internet Explorer is not supported by SecurOS WebConnect. Please use Google Chrome, ' +
            'Mozilla Firefox, Safari, MS Edge or other up-to-date browser.',

        // Статусы камер
        CAM_ALARMED: 'Alarmed',
        CAM_ARMED: 'Armed',
        CAM_DETACHED: 'No signal',
        CAM_DISARMED: 'Disarmed',
        CAM_DISARM_DETACHED: 'No signal',

        // Статусы событий
        EVENT_ATTACH: 'Camera connected',
        EVENT_BLINDING: 'Bad visibility',
        EVENT_DETACH: 'No video',
        EVENT_DEFOCUSED: 'Loss of focus',
        EVENT_FOCUSED: 'Focused',
        EVENT_MD_START: 'Alarm',
        EVENT_MD_STOP: 'End of alarm',
        EVENT_REC: 'Burn to disk',
        EVENT_REC_STOP: 'End of writing to disk',
        EVENT_UNBLINDING: 'Good visibility',
        EVENT_ARMED: 'The camera was armed',
        EVENT_DISARMED: 'The camera was disarmed',
        EVENT_REC_ERROR: 'Write error',

        // Работа с выгрузкой видео
        DOWNLOADING: 'Downloading',
        VIDEO_EXPORT_PERIOD: 'Choose export time period',
        'Video Complete': 'File is ready for download',
        'Video Loading': 'File is being prepared for download',

        // Кастомные ошибки валидации
        uniqueObject: 'That site name is in use. Please try another.',
        uniqueLogin: 'That login is in use. Please try another.',
        auth: "Sorry, we couldn't find an account with that login and password.",
        wrongPassword: 'Wrong password.',
        uniqueViewName: 'That view name is in use. Please try another.',
        disableRoot: 'Login as superuser (root) is prohibited by the security policy. Please use another user account.',
    }
}



// WEBPACK FOOTER //
// ./src/common/translates.js